<ds-modal [title]="'switcher' | translate" (modalClosed)="onClose()">
  <div class="margin-bottom-sm">
    <form [formGroup]="form">
      <app-searchbox
        [label]="'label_search_by_name' | translate"
        class="w-100"
        role="search"
        [placeholder]="'form_search' | translate"
        [formControlName]="$userSearch.searchTerm"
      ></app-searchbox>
    </form>
  </div>
  <ds-tree-menu
    [menuItems]="navItems$ | async"
    [menuAriaLabel]="'switcher' | translate"
    [rootItemsAlwaysExpanded]="true"
  ></ds-tree-menu>
</ds-modal>
